var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input-number',{attrs:{"controls":false,"placeholder":_vm.placeholder,"precision":2,"step":0.1},on:{"input":_vm.onChangeInput},model:{value:(_vm.getAmount),callback:function ($$v) {_vm.getAmount=$$v},expression:"getAmount"}})
}
var staticRenderFns = []

export { render, staticRenderFns }